export default {
  // Login.vue
  'E-Funeral': 'E-Funeral',
  'Email address': 'E-Mail-adresse',
  'Password': 'Passwort',
  'Wrong username or password.': 'Sie haben eine falsche E-Mail-Adresse oder ein falsches Passwort eingegeben. Versuchen Sie es bitte noch einmal?',
  'Login': 'Einloggen',
  'Unnamed Video': 'Unbenanntes Video'
}
